// Standard predefined products for Universal Electricals & Electronics
// Used in Quotations, Proforma Invoices, and Purchase Orders to auto-populate
// Product Name, Description (details), HSN Code, and Product Manual URL.

export const STANDARD_PRODUCTS = [
  {
    name: "Proximity Warning Device",
    description: "Radar Based (Single) Sensor, Detection Range 10–12 MTR, Operating Voltage: 12–36VDC",
    hsn_code: "8531",
    manual_url: "/api/uploads/files/0df5fb50-d44a-460e-b860-04ec47a02004_PROXIMITY_WARNING_SYSTEM_Short_Range___12-17_Meters.pdf",
  },
  {
    name: "Driver Fatigue Monitoring System",
    description: "Offline Device",
    hsn_code: "8524",
    manual_url: "/api/uploads/files/27ed0026-a13d-4910-ba11-a095a2392eb3_Drive_fatigue_monitor_system.pdf",
  },
  {
    name: "Anti Tilt Device",
    description: "With Dalla & Break Interlocking System",
    hsn_code: "8531",
    manual_url: "/api/uploads/files/182572c8-074d-4937-8194-c61818223f76_ANTI_TILT_battery__1___1_.pdf",
  },
  {
    name: "Automatic Fire Detection Suppression System",
    description: "25LBS, 6 Nozzle, Single Zone System",
    hsn_code: "8704",
    manual_url: "/api/uploads/files/08f7d207-e7f7-4fa1-8c4f-583590d3b9a7_A4_AFDSS_MANUAL_compressed.pdf",
  },
  {
    name: "Rear View Camera System",
    description: '7" HD Display, 1080P Resolution, IP69K Grade 2MP Camera, 15 MTR Connecting Cable',
    hsn_code: "8525",
    manual_url: "/api/uploads/files/6ed9931a-c98f-4506-a17d-bd5a06fedcb0_rear_view_camera__2_.pdf",
  },
  {
    name: "Body Lifting Alarm (System)",
    description: "Body Lifting Alarm System",
    hsn_code: "8531",
    manual_url: "/api/uploads/files/801f4072-473d-4e67-946f-15433e4c8143_body_lifting_with_anti_lock_system.pdf__2_.pdf",
  },
  {
    name: "Seat Belt Voice Reminder",
    description: "With Electronic Latch, Human Voice (Hindi & English), Working Voltage: 12–24VDC",
    hsn_code: "8531",
    manual_url: "/api/uploads/files/b65305f3-e657-4cde-9a26-699e1dfe6c9a_seat_belt_nevaly.pdf.pdf",
  },
  {
    name: "Audio Visual Alarm",
    description: "Dual Piezo Buzzer, Blinking Red LED, Operating Voltage: 12–36VDC",
    hsn_code: "8531",
    manual_url: "/api/uploads/files/ac9cb848-3de5-4033-9d3c-e8fca6f5e8b9_Audio_Visual_Alarm.pdf",
  },
  {
    name: "Battery Cut-Off Switch",
    description: "Battery Cut-Off Switch",
    hsn_code: "8536",
    manual_url: "/api/uploads/files/31caeb5f-6dfb-453e-8e2a-0598601708e9_battery_cut_off_switch_data_RED.pdf",
  },
  {
    name: "Travel Alarm",
    description: "Travel Alarm System",
    hsn_code: "8531",
    manual_url: "/api/uploads/files/1b1f3e40-c9ea-401f-9cbe-86d2bc9ec58e_pre_start_alarm__2_.pdf",
  },
];
